import { render, staticRenderFns } from "./nodeWrap.vue?vue&type=template&id=2de8b2f6&scoped=true"
import script from "./nodeWrap.vue?vue&type=script&lang=js"
export * from "./nodeWrap.vue?vue&type=script&lang=js"
import style0 from "./nodeWrap.vue?vue&type=style&index=0&id=2de8b2f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8b2f6",
  null
  
)

export default component.exports